module.exports = __webpack_public_path__ + "media/images/user/favicons/site-tile-70x70-e424ee735a4f502a8f88a35c3d936fc6.png";